import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BookingFacade } from '@booking/booking.facade';

@Pipe({
  name: 'countryName',
  standalone: false
})
export class CountryNamePipe implements PipeTransform {

  constructor(private facade: BookingFacade) { }

  transform(code: string): Observable<string> {
    return this.facade.countries$
      .pipe(
        map(countries => {
          const countryString = countries.find(country => country.trim().endsWith(`(${code})`)) || code;
          const slice = countryString.lastIndexOf('(');
          return slice > 0 ? countryString.slice(0, slice) : countryString;
        })
      );
  }
}
